import * as SwitchPrimitive from "@radix-ui/react-switch";
import styles from "./Switch.module.scss";

interface SwitchProps {
  value: boolean;
  onChange: (newValue: boolean) => void;
  disabled?: boolean;
}

function Switch({ value, onChange, disabled = false }: SwitchProps) {
  return (
    <SwitchPrimitive.Root
      checked={value}
      onCheckedChange={onChange}
      disabled={disabled}
      className={styles.Root}
    >
      <SwitchPrimitive.Thumb className={styles.Thumb} />
    </SwitchPrimitive.Root>
  );
}

export default Switch;